// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class SearchInfoPlugin {
   quickFilters: any
   static initClass() {
      // @ts-expect-error TS(2339) FIXME: Property 'states' does not exist on type 'SearchIn... Remove this comment to see the full error message
      this.prototype.states = ['new']
   }
   constructor(quickFilters: any) {
      this.quickFilters = quickFilters
   }

   invoke(data: any, feed: any) {
      const info = data.search
      const {
         query
      } = info
      const sortInfo = _.first(query.sort)
      const qe = query.query_expansion
      var item = {
         query: query.original_query,
         recordCount: info.record_count,
         type: 'searchInfo',
         terms:  qe.search_terms,
         sortOrder: sortInfo ? `${sortInfo.field_name}|${sortInfo.sort_order}` : "relevance",
         sortType(type: any) { return type === item.sortOrder },
         inLibraryCatalog: !this.quickFilters.isApplied({label: "Library Catalog", facet: "SourceType", value: "Library Catalog"})
      }
      return feed.addPositionalItem(item, 1)
   }
}
SearchInfoPlugin.initClass()

SearchInfoPlugin.$inject = ['quickFiltersService']

angular.module('summonApp.resultsFeedPlugins')
   .service('searchInfoPlugin', SearchInfoPlugin)
